export const lightTheme = {
  colors: {
    bg: '#FEFEFD',
    bgLayout: '#FAFCF6',
    surface: '#FFFFFF',
    line: '#ECECEA',
    line2: '#F4F4F1',
    inputBorder: '#D6D5CF',
    inputBorderHover: '#BDBCB6',
    icon: '#6E7E6C',
    ink: '#0A0A0A',
    ink2: '#3F3F3F',
    ink3: '#757575',
    ink4: '#A3A3A3',
    accent: '#C5F230',
    accentDeep: '#A8D920',
    accentSoft: '#E8F4DA',
    success: '#22C55E',
    danger: '#EF4444',
    warning: '#F59E0B',
    successSoft: '#E0F5E6',
    dangerSoft: '#FBE3E3',
    warningSoft: '#FCEFD6',
  },
  radii: {
    sm: '0.375rem',
    md: '0.75rem',
    lg: '1.375rem',
    pill: '999px',
  },
  fonts: {
    sans: "'Geist', 'Heebo', system-ui, -apple-system, sans-serif",
    mono: "'JetBrains Mono', source-code-pro, monospace",
  },
  text: {
    xs: '0.6875rem',
    sm: '0.75rem',
    md: '0.8125rem',
    lg: '0.875rem',
    xl: '1rem',
  },
  textMobile: {
    xs: '0.625rem',
    sm: '0.6875rem',
    md: '0.75rem',
    lg: '0.8125rem',
    xl: '0.875rem',
  },
  heading: {
    h1: '1.5rem',
    h2: '1.125rem',
    h3: '1rem',
  },
  headingMobile: {
    h1: '1.25rem',
    h2: '1.0625rem',
    h3: '0.9375rem',
  },
  breakpoints: {
    mobile: '540px',
  },
  shadows: {
    card: '0 1px 2px rgba(0,0,0,0.02), 0 32px 60px -20px rgba(0,0,0,0.10)',
    focus: '0 0 0 4px rgba(197,242,48,0.25)',
    submitHover: '0 8px 24px rgba(168,217,32,0.35)',
  },
  motion: {
    fast: '120ms',
    base: '200ms',
  },
} as const

export type AppTheme = typeof lightTheme
